export default __webpack_public_path__ + "static/media/game-3.17ea68ef.png";